import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const PaymentCancel = () => {
  const { lang } = useLang();
  const copy = {
    fr: {
      title: "Paiement annulé",
      text: "Votre paiement a été annulé et aucune somme n'a été débitée. Vous pouvez réessayer quand vous le souhaitez.",
      home: "Retour à l'accueil",
      retry: "Voir les activités",
    },
    en: {
      title: "Payment cancelled",
      text: "Your payment was cancelled and no amount was charged. You can try again whenever you like.",
      home: "Back to home",
      retry: "View activities",
    },
  }[lang];

  return (
    <div className="min-h-screen bg-[#f7f5ef] flex items-center justify-center px-5 pt-24 pb-16">
      <div className="max-w-lg w-full bg-white rounded-3xl border border-[#eceae1] p-10 md:p-12 text-center shadow-[0_25px_60px_-30px_rgba(28,34,30,0.35)]">
        <div className="w-16 h-16 rounded-full bg-[#f0e7e3] mx-auto flex items-center justify-center mb-6">
          <XCircle size={32} className="text-[#b98b6e]" />
        </div>
        <h1 className="font-serif text-4xl text-[#20261f] mb-4">{copy.title}</h1>
        <p className="text-[#6b7166] leading-relaxed mb-8">{copy.text}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 border border-[#dedbd0] text-[#3d443a] px-6 py-3 rounded-full text-sm tracking-wide hover:border-[#7c8f74] transition"
          >
            {copy.home}
          </Link>
          <Link
            to="/activites"
            className="inline-flex items-center justify-center gap-2 bg-[#7c8f74] hover:bg-[#697c62] text-white px-6 py-3 rounded-full text-sm tracking-wide transition"
          >
            {copy.retry} <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
